import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCamera2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconCamera2"><Path fillRule="evenodd" clipRule="evenodd" d="M8.25785 5C9.06446 3.7949 10.4391 3 12 3C13.5609 3 14.9355 3.7949 15.7422 5H19.5C20.8807 5 22 6.11929 22 7.5L22 18.5C22 19.8807 20.8807 21 19.5 21H4.50001C3.1193 21 2.00001 19.8807 2.00001 18.5L2 7.5C2 6.11929 3.11929 5 4.5 5H8.25785ZM8.25 12.5C8.25 10.4289 9.92893 8.75 12 8.75C14.0711 8.75 15.75 10.4289 15.75 12.5C15.75 14.5711 14.0711 16.25 12 16.25C9.92893 16.25 8.25 14.5711 8.25 12.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCamera2;
